var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fa-stack task-check-circle",class:{ 'check-visible': _vm.showCheck }},[_c('font-awesome-icon',{staticClass:"fa-stack-2x circle",attrs:{"icon":['fas', 'circle']}}),(_vm.showCheck)?_c('font-awesome-icon',{staticClass:"fa-stack-1x fa-inverse",attrs:{"icon":['fas', 'check']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }